import { Box, Typography, IconButton } from '@mui/material';


interface PageHeaderProps {
  onBack: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ onBack }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <IconButton 
        onClick={onBack}
        sx={{ 
          backgroundColor: '#F3F4F6', 
          '&:hover': { backgroundColor: '#E5E7EB' },
          width: 40,
          height: 40
        }}
      >
     
      </IconButton>
      <Typography variant="h4" sx={{ fontWeight: 600, color: '#101E36' }}>
        Detalhes do Comunicado
      </Typography>
    </Box>
  );
};